import { LangText } from '@/components';

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full">
      {/* 从上往下渐变，分上下两行 */}
      <div
        className="w-full text-white"
        style={{ background: 'linear-gradient(180deg, #A75AFF, #4B51FF)' }}
      >
        {/* 上部分：品牌 + 三列链接，横向分布 */}
        <div className="flex gap-12 justify-between items-start pt-8 pb-10 mx-auto max-w-12xl px-25">
          <div>
            <span className="text-[36px] font-bold tracking-wider uppercase block">BILION PASS</span>
            <span className="text-[16px] text-white my-3 block"><LangText lngKey="f665074c" /></span>
          </div>
          <div className="flex flex-col gap-4 mt-1 text-left">
          </div>
          <div className="flex flex-col gap-4 mt-1 text-left">
            <span className="text-[16px] mb-1"><LangText lngKey="f6db7790" /></span>
            <a href="/about" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="66972f94" /></a>
            <a href="/contact" className="text-[14px] text-[#ccc] hover:text-white"><LangText lngKey="2c7782ea" /></a>
          </div>
          <div className="flex flex-col gap-4 mt-1 text-left">
            <span className="text-[16px] mb-1"><LangText lngKey="d01d50dd" /></span>
            <span className="text-[14px] text-[#ccc] cursor-pointer hover:text-white" onClick={() => window.open('/protocol?id=2', '_blank')}><LangText lngKey="5a8543c4" /></span>
            <span className="text-[14px] text-[#ccc] cursor-pointer hover:text-white" onClick={() => window.open('/protocol?id=3', '_blank')}><LangText lngKey="39d02547" /></span>
          </div>
        </div>
        {/* 下部分：版权左 + 社交图标右，窄条 */}
        <div className="flex justify-between items-center pt-10 pb-4 mx-auto max-w-12xl px-25">
          <span className="text-[14px] text-[#CBCBCB]">© {year} <LangText lngKey="a7ec1656" /></span>
        </div>
      </div>
    </footer>
  );
}
